export const PAYMENT_URL = "";
export const PAYMENT_LABEL = "Make a Payment";
